
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeTankerFilled as ObiVesselTypeTankerFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-tanker-filled.js';
 
 
 

 
 export const ObiVesselTypeTankerFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-tanker-filled',
   elementClass: ObiVesselTypeTankerFilledElement,
   events: {
     
   }
  });
 
 